import { Navigate, Outlet } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import Cookies from "js-cookie";
import { COOKIE_KEY, DECRYPT_KEY } from '../../utils/constants/GlobalConstants';

const RestrictRoute = ({ isAuthenticated, redirectTo }) => {
    const encryptF = Cookies.get(COOKIE_KEY);
    const bytes = encryptF && CryptoJS.AES.decrypt(encryptF, DECRYPT_KEY);
    const decryptData = bytes && JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    const role = decryptData?.group;
    return isAuthenticated.includes(role) ? <Outlet /> : <Navigate to={redirectTo} />;
};

export default RestrictRoute;